<template>
  <div>
    <div class="margin-top flex justify-between">
      <div >
        <el-select v-model="simplifyCarFeeInfo.carId" @change="changeSimplifyCar">
          <el-option
            v-for="(item,index) in simplifyCarFeeInfo.ownerCars"
            :key="index"
            :label="item.carNum"
            :value="item.carId">
          </el-option>
        </el-select>
      </div>
      <div  v-if="simplifyCarFeeInfo.carId">
        <el-button type="primary" size="small" @click="_toBuyCarMonthCard">
          {{ $t('simplifyCarFee.buyMonthCard') }}
        </el-button>
        <el-button type="primary" size="small" v-if="simplifyCarFeeInfo.ownerId" @click="_openBatchPayCarFeeModal">
          {{ $t('simplifyCarFee.batchPayment') }}
        </el-button>
        <el-button type="primary" size="small" @click="_openSimplifyCarCreateFeeAddModal">
          {{ $t('simplifyCarFee.createFee') }}
        </el-button>
      </div>
    </div>

    <el-row class="batch-toolbar" v-if="selection.length > 0">
      <el-col :span="24">
        <span class="selected-tip">{{ $t('simplifyCarFee.selectedCount') }}{{ selection.length }}{{ $t('simplifyCarFee.items') }}</span>
        <el-button type="danger" size="small" v-if="hasPrivilege('502020090604200029')" @click="batchDeleteFee">
          <i class="el-icon-delete"></i>
          {{ $t('simplifyCarFee.batchCancelFee') }}
        </el-button>
        <el-button size="small" @click="clearSelection">{{ $t('simplifyCarFee.clearSelection') }}</el-button>
      </el-col>
    </el-row>
    <!-- 按费用名称分组显示 -->
    <div v-for="(group, gIdx) in carFeeGroups" :key="'car_' + gIdx" class="fee-group">
      <div class="group-title">{{ group.feeName }}（{{ group.fees.length }}条）</div>
      <el-table
        :data="group.fees"
        style="width: 100%"
        border stripe size="mini"
        @selection-change="(rows) => onGroupSelectionChange(rows, gIdx)"
        row-key="feeId">
        <el-table-column type="selection" width="40" :selectable="checkSelectable" />
        <el-table-column prop="feeTypeCdName" :label="$t('simplifyCarFee.feeType')" align="center" width="90" />
        <el-table-column :label="$t('simplifyCarFee.amountReceivable')" align="center" width="85">
          <template #default="{row}">
            {{ _getDisplayAmount(row) }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('simplifyCarFee.accountingTime')" align="center" width="100">
          <template #default="{row}">
            {{ (row.startTime || '').substring(0, 10) }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('simplifyCarFee.receivablePeriod')" align="center" min-width="130">
          <template #default="{row}">
            {{ _getReceivablePeriod(row) }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('simplifyCarFee.description')" align="center" min-width="130">
          <template #default="{row}">
            <div v-if="row.feeTypeCd == '888800010015' || row.feeTypeCd == '888800010016'">
              <div>{{ $t('simplifyCarFee.lastDegree') }}：{{row.preDegrees}}</div>
              <div>{{ $t('simplifyCarFee.currentDegree') }}：{{row.curDegrees}}</div>
              <div>{{ $t('simplifyCarFee.unitPrice') }}：{{row.squarePrice}}</div>
              <div>{{ $t('simplifyCarFee.additionalFee') }}：{{row.additionalAmount}}</div>
            </div>
            <div v-else-if="row.feeTypeCd == '888800010017'">
              <div>{{ $t('simplifyCarFee.algorithm') }}：{{_getAttrValue(row.feeAttrs,'390005')}}</div>
              <div>{{ $t('simplifyCarFee.usage') }}：{{_getAttrValue(row.feeAttrs,'390003')}}</div>
            </div>
            <div v-else>
              <div>{{ $t('simplifyCarFee.unitPrice') }}：{{row.squarePrice}}</div>
              <div>{{ $t('simplifyCarFee.fixedFee') }}：{{row.additionalAmount}}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="stateName" :label="$t('simplifyCarFee.status')" align="center" width="80" />
        <el-table-column :label="$t('simplifyCarFee.operation')" align="center" width="160">
          <template #default="{row}">
            <el-button type="text" size="small" v-if="row.state != '2009001' && hasPrivilege('502020082314267912')" @click="_simplifyCarPayFee(row)">
              {{ $t('simplifyCarFee.payment') }}
            </el-button>
            <el-button type="text" size="small" @click="_simplifyCarPayFeeHis(row)">
              {{ $t('simplifyCarFee.paymentHistory') }}
            </el-button>
            <el-dropdown>
              <el-button type="text" size="small">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-if="row.isDefault == 'F' && hasPrivilege('502020090604200029')" @click.native="_simplifyCarDeleteFee(row)">
                  {{ $t('simplifyCarFee.cancelFee') }}
                </el-dropdown-item>
                <el-dropdown-item v-if="hasPrivilege('502021070488970005')" @click.native="_simplifyCarFinishFee(row)">
                  {{ $t('simplifyCarFee.manualFinish') }}
                </el-dropdown-item>
                <el-dropdown-item v-if="row.state != '2009001' && hasPrivilege('502020090427190001')" @click.native="_simplifyCarEditFee(row)">
                  {{ $t('simplifyCarFee.feeChange') }}
                </el-dropdown-item>
                <el-dropdown-item>
                  <a target="_blank" :href="'/#/views/fee/feeDetail?feeId='+row.feeId">
                    {{ $t('simplifyCarFee.details') }}
                  </a>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-row>
      <el-col :span="12">
        <div>{{ $t('simplifyCarFee.note1') }}</div>
        <div>{{ $t('simplifyCarFee.note2') }}</div>
      </el-col>
      <el-col :span="6">
        <span>{{ $t('simplifyCarFee.arrearsSubtotal') }}：{{simplifyCarFeeInfo.totalAmount}}</span>
      </el-col>
    </el-row>
    <car-create-fee-add ref="carCreateFeeAdd" @success="handleNotify" />
    <delete-fee ref="deleteFee" @success="handleNotify"></delete-fee>
    <edit-fee ref="editFee" @success="handleNotify"></edit-fee>
    <finish-fee ref="finishFee" @success="handleNotify"></finish-fee>

  </div>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import { listFee, queryOwnerCars } from '@/api/simplify/simplifyCarFeeApi'
import { deleteFee } from '@/api/fee/deleteFeeApi'
import CarCreateFeeAdd from '@/components/fee/carCreateFeeAdd'
import DeleteFee from '@/components/fee/deleteFee'
import EditFee from '@/components/fee/editFee'
import FinishFee from '@/components/fee/finishFee'


export default {
  name: 'SimplifyCarFee',
  data() {
    return {
      simplifyCarFeeInfo: {
        fees: [],
        ownerCars: [],
        ownerId: '',
        name: '',
        carNum: '',
        carId: '',
        total: 0,
        records: 1,
        areaNum: '',
        num: '',
        parkingName: '',
        totalAmount: 0.0
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      selection: [], // 多选选中的费用项
      groupSelections: {} // 按表格分组追踪选中项
    }
  },
  computed: {
    carFeeGroups() {
      // 过滤掉已结束的(state=2009001)费用
      const activeFees = this.simplifyCarFeeInfo.fees.filter(fee => fee.state !== '2009001')
      const map = {}
      activeFees.forEach(fee => {
        const key = fee.feeName || '其他费用'
        if (!map[key]) map[key] = []
        map[key].push(fee)
      })
      const result = Object.keys(map).map(name => {
        map[name].sort((a, b) => {
          const tA = a.startTime ? new Date(a.startTime).getTime() : 0
          const tB = b.startTime ? new Date(b.startTime).getTime() : 0
          return tA - tB
        })
        return { feeName: name, fees: map[name] }
      })
      return result
    }
  },
  components: {
    CarCreateFeeAdd,
    DeleteFee,
    EditFee,
    FinishFee
  },
  created() {
    this.communityId = getCommunityId()

  },
  methods: {

    open(param) {
      this.handleSwitch(param)
    },
    handleSwitch(param) {
      // 没有业主、房屋ID、车辆ID，无法操作
      if (!param.ownerId && !param.roomId && !param.carId) return
      this.clearSimplifyCarFeeInfo()
      Object.assign(this.simplifyCarFeeInfo, param)
      this.listOwnerCar()
        .then(() => {
          this.listSimplifyCarFee()
        })
        .catch(() => {
          this.simplifyCarFeeInfo.carId = param.carId
          this.simplifyCarFeeInfo.carNum = param.carNum
          this.listSimplifyCarFee()
        })
    },
    handleNotify() {
      this.listSimplifyCarFee()
    },
    handleCurrentChange() {
      // 分页已移除，保留空方法兼容
    },
    listSimplifyCarFee() {
      if (!this.simplifyCarFeeInfo.carId) return
      
      const params = {
        page: 1,
        row: 500,
        communityId: this.communityId,
        payerObjId: this.simplifyCarFeeInfo.carId,
        orderBy: 'start_time'
      }
      
      listFee(params).then(res => {
        this.simplifyCarFeeInfo.fees = res.data.fees
        this.total = res.data.total
        let totalAmount = 0.0
        res.data.fees.forEach(item => {
          if (item.state !== '2009001') {
            totalAmount += parseFloat(item.amountOwed || 0)
          }
        })
        this.simplifyCarFeeInfo.totalAmount = totalAmount.toFixed(2)
      })
    },
    listOwnerCar() {
      return new Promise((resolve, reject) => {
        const params = {
          page: 1,
          row: 50,
          carTypeCd: '1001',
          communityId: this.communityId
        }
        // 车辆页面：直接查该车辆；房屋页面：通过roomId只查该房屋绑定的车辆
        if (this.simplifyCarFeeInfo.carId) {
          params.carId = this.simplifyCarFeeInfo.carId
        } else if (this.simplifyCarFeeInfo.roomId) {
          params.roomId = this.simplifyCarFeeInfo.roomId
        } else if (this.simplifyCarFeeInfo.ownerId) {
          params.ownerId = this.simplifyCarFeeInfo.ownerId
        }

        queryOwnerCars(params).then(res => {
          let _json = res.data;
          this.simplifyCarFeeInfo.ownerCars = _json.data
          if (_json.data.length > 0) {
            this.simplifyCarFeeInfo.carId = _json.data[0].carId
            this.simplifyCarFeeInfo.carNum = _json.data[0].carNum
            this.simplifyCarFeeInfo.num = _json.data[0].num
            this.simplifyCarFeeInfo.parkingName = `${_json.data[0].areaNum}${this.$t('simplifyCarFee.parkingLot')}${_json.data[0].num}${this.$t('simplifyCarFee.parkingSpace')}`
            // 如果通过roomId查询，且没有ownerId，将车辆属主信息也补上
            if (!this.simplifyCarFeeInfo.ownerId && _json.data[0].ownerId) {
              this.simplifyCarFeeInfo.ownerId = _json.data[0].ownerId
            }
            resolve(_json.data)
          } else {
            reject(this.$t('simplifyCarFee.noParkingSpace'))
          }
        }).catch(err => {
          reject(err)
        })
      })
    },
    changeSimplifyCar() {
      const car = this.simplifyCarFeeInfo.ownerCars.find(item => item.carId === this.simplifyCarFeeInfo.carId)
      if (!car) return
      
      this.simplifyCarFeeInfo.carNum = car.carNum
      this.simplifyCarFeeInfo.num = car.num
      this.simplifyCarFeeInfo.parkingName = `${car.areaNum}${this.$t('simplifyCarFee.parkingLot')}${car.num}${this.$t('simplifyCarFee.parkingSpace')}`
      this.listSimplifyCarFee()
    },
    clearSimplifyCarFeeInfo() {
      this.simplifyCarFeeInfo = {
        fees: [],
        ownerCars: [],
        ownerId: '',
        name: '',
        carNum: '',
        carId: '',
        total: 0,
        records: 1,
        areaNum: '',
        num: '',
        parkingName: '',
        totalAmount: 0.0
      }
    },
    _getEndTime(fee) {
      return fee.state == '2009001' ? '-' : fee.endTime
    },
    _getReceivablePeriod(fee) {
      if (fee.state === '2009001') {
        const startTime = (fee.startTime || '').substring(0, 10)
        const endTime = (fee.endTime || '').substring(0, 10)
        if (!startTime || !endTime) return '-'
        return startTime + '~' + endTime
      }
      const startTime = (fee.startTime || '').substring(0, 10)
      const endTime = (fee.endTime || '').substring(0, 10)
      if (!startTime || !endTime) return '-'
      return startTime + '~' + endTime
    },
    _getDeadlineTime(fee) {
      if (fee.amountOwed == 0 && fee.endTime == fee.deadlineTime) return '-'
      if (fee.state == '2009001') return '-'
      return fee.deadlineTime
    },
    _getDisplayAmount(fee) {
      // 有实际欠费金额时显示欠费金额
      if (fee.amountOwed && parseFloat(fee.amountOwed) > 0) {
        return parseFloat(fee.amountOwed).toFixed(2)
      }
      // 未到收费时间，显示单周期应收金额
      if (fee.feeTotalPrice && parseFloat(fee.feeTotalPrice) > 0) {
        return parseFloat(fee.feeTotalPrice).toFixed(2)
      }
      return fee.amountOwed || 0
    },
    _getAttrValue(attrs, code) {
      const attr = attrs.find(item => item.specCd === code)
      return attr ? attr.value : ''
    },
    _simplifyCarGetFeeOwnerInfo(attrs) {
      const ownerName = this._getAttrValue(attrs, '390008')
      const ownerLink = this._getAttrValue(attrs, '390009')
      return `${this.$t('simplifyCarFee.owner')}：${ownerName},${this.$t('simplifyCarFee.phone')}：${ownerLink}`
    },
    _simplifyCarPayFee(fee) {
      this.$router.push(`/views/fee/payFeeOrder?feeId=${fee.feeId}&ownerId=${this.simplifyCarFeeInfo.ownerId || ''}`)
    },
    _simplifyCarPayFeeHis(fee) {

      this.$router.push({
        path: '/views/fee/propertyFee',
        query: fee
      })
    },
    _simplifyCarEditFee(fee) {
      fee.maxEndTime = this._getAttrValue(fee.feeAttrs, '390010')
      this.$refs.editFee.open(fee)
    },
    _simplifyCarDeleteFee(fee) {
      this.$refs.deleteFee.open({
        communityId: getCommunityId(),
        feeId: fee.feeId
      })
    },
    _openSimplifyCarCreateFeeAddModal() {
      this.$refs.carCreateFeeAdd.open({ isMore: false, car: this.simplifyCarFeeInfo })
    },
    _simplifyCarFinishFee(fee) {
      this.$refs.finishFee.open({
        communityId: getCommunityId(),
        feeId: fee.feeId
      })
    },
    _toBuyCarMonthCard() {
      this.$router.push(`/views/fee/buyCarMonthCard?carNum=${this.simplifyCarFeeInfo.carNum}`)
    },
    _openBatchPayCarFeeModal() {
      this.$router.push(`/views/fee/batchPayFeeOrder?ownerId=${this.simplifyCarFeeInfo.ownerId}&payerObjType=6666`)
    },
    _viewCarFeeConfig(fee) {
      // Implement view fee config logic
      console.log(fee)
    },
    onGroupSelectionChange(rows, groupKey) {
      if (!this.groupSelections) this.groupSelections = {}
      this.groupSelections[groupKey] = rows
      clearTimeout(this.mergeTimer)
      this.mergeTimer = setTimeout(() => {
        const merged = []
        Object.values(this.groupSelections).forEach(groupRows => {
          groupRows.forEach(f => merged.push(f))
        })
        this.selection = merged
      }, 30)
    },
    checkSelectable(row) {
      // 默认费用(isDefault='T')和已结束的费用不可选
      return row.isDefault === 'F' && row.state !== '2009001'
    },
    clearSelection() {
      this.groupSelections = {}
      this.selection = []
    },
    batchDeleteFee() {
      if (this.selection.length === 0) {
        this.$message.warning(this.$t('simplifyCarFee.selectFeeFirst'))
        return
      }
      const confirmMsg = this.$t('simplifyCarFee.batchCancelConfirm').replace('{count}', this.selection.length)
      this.$confirm(
        confirmMsg,
        this.$t('deleteFee.title'),
        {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning',
          dangerouslyUseHTMLString: true
        }
      ).then(() => {
        this.doBatchDeleteFee()
      }).catch(() => { })
    },
    async doBatchDeleteFee() {
      const communityId = getCommunityId()
      const feeIds = this.selection.map(item => item.feeId)
      let successCount = 0
      let failCount = 0

      const loading = this.$loading({
        lock: true,
        text: this.$t('simplifyCarFee.deleting') || '正在批量取消费用...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      try {
        for (const feeId of feeIds) {
          try {
            const res = await deleteFee({ communityId, feeId })
            if (res.code === 0) {
              successCount++
            } else {
              failCount++
            }
          } catch (err) {
            failCount++
          }
        }
        loading.close()

        if (successCount > 0) {
          const msg = this.$t('simplifyCarFee.batchCancelSuccess').replace('{count}', successCount)
          this.$message.success(msg)
        }
        if (failCount > 0) {
          const msg = this.$t('simplifyCarFee.batchCancelFail').replace('{count}', failCount)
          this.$message.warning(msg)
        }
        this.handleNotify()
      } catch (error) {
        loading.close()
        console.error('批量取消费用失败:', error)
      }
    }
  }
}
</script>

<style scoped>
.hand {
  cursor: pointer;
}
.margin-top {
  margin-top: 10px;
}

.batch-toolbar {
  margin-bottom: 10px;
  padding: 8px 12px;
  background: #fef0f0;
  border: 1px solid #fde2e2;
  border-radius: 4px;
}

.batch-toolbar .selected-tip {
  color: #f56c6c;
  font-size: 14px;
  margin-right: 15px;
  font-weight: 500;
}

.fee-group {
  margin-bottom: 10px;
}

.group-title {
  font-size: 14px;
  font-weight: bold;
  color: #303133;
  padding: 6px 0;
  margin-bottom: 2px;
  border-bottom: 2px solid #E6A23C;
}
</style>